/**
 * base - 组件相关
 *
 * @author Shigq
 * @date 2021/4/14 18:28
 */
import { useI18n } from '@/plugins/i18n'
import { commonUtils } from '@libs/utils'

const { t } = useI18n()

const localeMap = {
  'zh-cn': {
    country: 'cnName',
    econtinent: 'ccontinent',
    // 排序采用的语言
    sortLocale: 'zh-CN'
  },
  'en': {
     country: 'enName',
     econtinent: 'econtinent',
     sortLocale: 'en-US'
  }
}

const assembleCountryCode = countryData => {
  const i18 = useI18n()
  let locale = i18.locale || 'en'
  const currentLocaleMap = localeMap[locale] || localeMap['en']
  // inner methods
  const assembleContinentName = function (country) {
    if(locale=="zh-cn"){
      return country.cname
    }
    return country.ename
    
  }
  const assembleCountryName = function (country) {
    if(locale=="zh-cn"){
      return country.cname
    }
    return country.ename
  }
  const assembleCountryMap = function (map, country){
    if (!map[country.econtinent]) {
      map[country.econtinent] = {
        id: country.econtinent,
        label: assembleContinentName(country),
        options: []
      }
    }
    map[country.econtinent].options.push({
      value: country.id,
      label: assembleCountryName(country)
    })
  }

  // result
  const result = {
    list: [],
    listWithoutRisk: [],
    listWithRisk: [],
    areaMap: {},
    areaMapWithoutRisk: {},
    map: {},
    countryCodeList: []
  }

  let pushData = {

  }
  
  // handle
  countryData.list.forEach(country => {
    // countryCode接口设计缺陷，导致切换语言后，需要拿不同字段，此处做兼容处理
   
    result.list.push(country)
    result.map[country.id] = assembleCountryName(country)
    assembleCountryMap(result.areaMap, country)
    if (country.highRiskFlag !== 'F') {
      result.listWithoutRisk.push(country)
      result.countryCodeList.push({
        label: assembleCountryName(country),
        value: country.id
      })
      assembleCountryMap(result.areaMapWithoutRisk, country)
    } else {
      result.listWithRisk.push(country)
    }
  })

  // set
  pushData.list = result.listWithoutRisk
  pushData.map = result.map
  pushData.highRisklist = result.listWithRisk
  pushData.areaList = Object.values(result.areaMap)
  pushData.areaListWithoutRisk = Object.values(result.areaMapWithoutRisk)
  pushData.countryCodeList = result.countryCodeList.sort((a, b) => a.label.localeCompare(b.label, currentLocaleMap.sortLocale))

  return pushData
}

const PARAMS = {
  DICT_TYPE: {
    BASE: Symbol.for('base'),
    STATIC: Symbol.for('static'),
    COUNTRY_CODE: Symbol.for('countryCode'),
    CURRENCY: Symbol.for('currency'),
    SUPPORT_CUR: Symbol.for('supportCur')
  }
}

export default {
  state: {
    constant: {},
    dict: {},
    country: {
      map: {},
      list: []
    },
    countryTemp: [
      {
        id: "CN",
        code: "156",
        zoneNumber: "+86",
        highRiskFlag: "0",
        econtinent: "AS",
        cname: "中国大陆",
        ename: "CHINA",
        enameAbbr: null,
        ccontinent: "亚洲"
      },
      {
        id: "HK",
        code: "344",
        zoneNumber: "+852",
        highRiskFlag: "0",
        econtinent: "AS",
        cname: "中国香港",
        ename: "HONG KONG",
        enameAbbr: null,
        ccontinent: "亚洲"
      },
      {
        id: "TW",
        code: "158",
        zoneNumber: "+886",
        highRiskFlag: "N",
        econtinent: "AS",
        cname: "中国台湾",
        ename: "TAIWAN, PROVINCE OF CHINA",
        enameAbbr: "TWN",
        ccontinent: "亚洲"
      },
      {
        id: "SG",
        code: "702",
        zoneNumber: "+65",
        highRiskFlag: "0",
        econtinent: "AS",
        cname: "新加坡",
        ename: "SINGAPORE",
        enameAbbr: null,
        ccontinent: "亚洲"
      },
      {
        id: "US",
        code: "840",
        zoneNumber: "+1",
        highRiskFlag: "N",
        econtinent: "NA",
        cname: "美国",
        ename: "UNITED STATES OF AMERICA",
        enameAbbr: "USA",
        ccontinent: "北美洲"
      },{
        id: "ID",
        code: "360",
        zoneNumber: "+62",
        highRiskFlag: "N",
        econtinent: "AS",
        cname: "印度尼西亚",
        ename: "INDONESIA",
        enameAbbr: "IDN",
        ccontinent: "亚洲"
      }
    ],
    curTemp: { CNH: '人民币',TWD:'新台币',HKD:'港币', USD: '美元', SGD: '新加坡元', IDR: '印尼盾' },
  },
  mutations: {
    updateConstant(state) {
      state.constant = {
        RSP_ITEM_TYPE: {
          MAPPING: Symbol.for('MAPPING'),
          // MAPPING OBJ
          MAPPING_EXTRA: Symbol.for('MAPPING_EXTRA'),
          MAPPING_TAG: Symbol.for('MAPPING_TAG'),
          AMOUNT: Symbol.for('AMOUNT'),
          RATE: Symbol.for('RATE'),
          DATE: Symbol.for('DATE'),
          COMP: Symbol.for('COMP')
        },
        REQ_ITEM_TYPE: {
          INPUT: Symbol.for('INPUT'),
          SELECT: Symbol.for('SELECT'),
          SELECT_GROUP: Symbol.for('SELECT_GROUP'),
          DATE: Symbol.for('DATE'),
          RANGE_DATE: Symbol.for('RANGE_DATE'),
          CHECKBOX: Symbol.for('CHECKBOX'),
          RADIO: Symbol.for('RADIO'),
          UPLOAD_FILE: Symbol.for('UPLOAD_FILE')
        },
        LOGIN_MODE: {
          CELLPHONE: 'cellphone',
          EMAIL: 'email'
        },
        RESET_MODE: {
          CELLPHONE: 'cellphone',
          EMAIL: 'email'
        },
        EMAIL_TYPE: {
          REGISTER: '3',
          FORGET_PASSWORD: '5'
        },
        FILE: {
          UPLOAD_MODE: {
            READONLY: 'readonly',
            EDITABLE: 'editable',
            VIEW: 'view'
          },
          UPLOAD_STATUS: {
            INIT: '9',
            PROCESSING: '8',
            SUCCESS: '1',
            FAILED: '0'
          },
          BIZ_TYPE: { // 文件类型 (KY: kyc材料；AG :协议材料)
            KY: 'KY',
            AG: 'AG',
          },
          PREFIX: {
            REG_CERT_FILE: 'regCertFile',
            FRONT_FILE: 'frontFile', // 证件前面
            BACK_FILE: 'backFile', // 证件背面
            PASSPORT: 'passport',
            AUTH_FILE: 'authFile', // 授权文件
            HOLD_PHONE: 'holdPhoto', // 手持照片
            BUSINESS: 'business', // 公司信息
            OTHER_MATERIAL: 'otherMaterial', // 其他材料的
            AGREEMENT: 'agreement', // 其他材料的
          }
        }
      }
    },
    updateDict(state, { type = PARAMS.DICT_TYPE.BASE, payload = {} } = {}) {
      try {
        if (type === PARAMS.DICT_TYPE.BASE) {
          for (const i in payload) {
            state.dict[i] = payload[i]
          }
        } else if (type === PARAMS.DICT_TYPE.STATIC) {
          state.dict = Object.assign({}, state.dict, payload)
        } else if (type === PARAMS.DICT_TYPE.COUNTRY_CODE) {
          
          state.dict = Object.assign({}, state.dict, {
            country:  assembleCountryCode(payload)
          })
        } else if (type === PARAMS.DICT_TYPE.CURRENCY) {
          const currency = {
            map: {},
            mappings: {},
            options: []
          }

          payload.forEach(item => {
            currency.map[item.cur] = item
            currency.mappings[item.cur] = item.cur
            currency.options.push({
              label: item.cur,
              value: item.cur
            })
          })

          state.dict = Object.assign({}, state.dict, {
            currency: currency
          })
        } else if (type === PARAMS.DICT_TYPE.SUPPORT_CUR) {
          const supportCur = {
            mappings: {},
            options: []
          }

          payload.forEach(item => {
            supportCur.mappings[item] = item
            supportCur.options.push({
              label: item,
              value: item
            })
          })

          state.dict = Object.assign({}, state.dict, {
            supportCur: supportCur
          })
        } else {
          // todo
          // console.log('updateDict#EMPTY')
        }
      } catch (e) {
        console.error('updateDict#e', e)
      }
    }
  },
  actions: {
    updateDict({ commit }, dict) {
      // online
      commit('updateDict', { payload: dict })
      // override
      commit('updateDict', {
        type: PARAMS.DICT_TYPE.STATIC,
        payload: staticDict
      })
    },
    updateEcCountryAndPlatform({ commit }, payload) {
      commit('updateDict', {
        type: PARAMS.DICT_TYPE.STATIC,
        payload: payload
      })
    },
    updateConstant({ commit }, constant) {
      commit('updateConstant', constant)
    },
    updateCountry({ state, commit }, country) {
      commit('updateDict', {
        type: PARAMS.DICT_TYPE.COUNTRY_CODE,
        payload: country
      })
    },
    updateCurrency({ commit }, currency) {
      commit('updateDict', {
        type: PARAMS.DICT_TYPE.CURRENCY,
        payload: currency
      })
    },
    updateSupportCur({ commit }, supportCur) {
      commit('updateDict', {
        type: PARAMS.DICT_TYPE.SUPPORT_CUR,
        payload: supportCur
      })
    }
  }
}

const staticDict = {
  // AUTH
  authIdType: {
    mappings: {
      I: '身份证',
      P: '护照',
      H: '港澳通行证'
    },
    options: [
      { label: '身份证', value: 'I' },
      { label: '护照', value: 'P' },
      { label: '港澳通行证', value: 'H' }
    ]
  },
  // BENE
  beneType: {
    mappings: {
      0: '自身银行账户',
      1: '第三方收款人账户'
    },
    options: [
      { label: '自身银行账户', value: '0' },
      { label: '第三方收款人账户', value: '1' }
    ]
  },
  routeType: {
    mappings: {
      SW: 'SWIFT CODE',
      AB: 'ABA',
      IB: 'IBAN'
    },
    options: [
      { label: 'SWIFT CODE', value: 'SW', areaCode: '' },
      { label: 'ABA', value: 'AB', areaCode: 'NA' },
      { label: 'IBAN', value: 'IB', areaCode: 'EU' }
    ]
  },
  beneCheckStatusExtra: {
    mappings: {
      WC: { label: '待审核', type: 'warning' },
      CP: { label: '审核中', type: 'warning' },
      CF: { label: '已通过', type: 'success' },
      RJ: { label: '已驳回', type: 'danger' },
      RC: { label: '驳回已提交', type: 'warning' },
      ST: { label: '已停用', type: 'default' }
    },
    options: [
      { label: '待审核', value: 'WC' },
      { label: '审核中', value: 'CP' },
      { label: '已通过', value: 'CF' },
      { label: '已驳回', value: 'RJ' },
      { label: '驳回已提交', value: 'RC' },
      { label: '已停用', value: 'ST' }
    ]
  },
  // TXN
  txnType: {
    mappings: {
      0: '进口购汇',
      1: '出口结汇'
    },
    options: [
      { label: '进口购汇', value: '0' },
      { label: '出口结汇', value: '1' }
    ]
  },
  txnStatusExtra: {
    mappings: {
      TL: { label: '已锁汇', type: 'primary' },
      WP: { label: '待支付', type: 'danger' },
      PP: { label: '已受理', type: 'warning' },
      PA: { label: '已受理', type: 'warning' },
      BP: { label: '银行处理中', type: 'warning' },
      BS: { label: '出账成功', type: 'success' },
      TC: { label: '交易取消', type: 'danger' }
    },
    options: [
      { label: '已锁汇', value: ['TL'] },
      { label: '待支付', value: ['WP'] },
      { label: '已受理', value: ['PP', 'PA'] },
      { label: '银行处理中', value: ['BP'] },
      { label: '出账成功', value: ['BS'] },
      { label: '交易取消', value: ['TC'] }
    ]
  },
  // ORDER
  bankStatusExtra: {
    mappings: {
      null: { label: '未添加', type: 'default' },
      WC: { label: '待审核', type: 'primary' },
      CP: { label: '审核中', type: 'primary' },
      CF: { label: '已通过', type: 'success' },
      RJ: { label: '已驳回', type: 'danger' },
      RC: { label: '待审核', type: 'primary' }
    },
    options: [
      { label: '未添加', value: null },
      { label: '待审核', value: 'WC' },
      { label: '审核中', value: 'CP' },
      { label: '已通过', value: 'CF' },
      { label: '已驳回', value: 'RJ' },
      { label: '待审核', value: 'RC' }
    ]
  },
  // orderType 后端返回的顺序不对
  orderType: {
    mappings: {
      P: '货到付款',
      A: '预付货款'
    },
    options: [
      { label: '货到付款', value: 'P' },
      { label: '预付货款', value: 'A' }
    ]
  },
  curEnum: [
    "USD",
    "CNH",
    "CNY",
    "HKD",
    "GBP",
    "EUR",
    "JPY",
    "CAD",
    "AUD",
    "NZD",
    "SGD",
    "CHF",
    "AED",
    "THB",
    "SEK",
    "NOK",
    "VND",
    "MYR",
    "PHP",
    "KRW",
    "IDR",
    "BHD",
    "ZAR",
    "KES",
  ],
  bankAcctType: {
    mappings: {
      2: '个人',
      1: '企业'
    },
    options: [
      { label: '个人', value: '2' },
      { label: '企业', value: '1' }
    ]
  },
  // SETTLEMENT
  settlementStatus: {
    mappings: {
      0: { label: t('settlement.underReview'), tagType: 'warning' },
      3: { label: t('settlement.pending'), tagType: 'primary' },
      1: { label: t('settlement.settled'), tagType: 'success' },
      4: { label: t('settlement.returned'), tagType: 'danger' }
    },
    options: [
      { label: t('settlement.underReview'), value: '0' },
      { label: t('settlement.pending'), value: '3' },
      { label: t('settlement.settled'), value: '1' },
      { label: t('settlement.returned'), value: '4' }
    ]
  },
  checkStatus: {
    mappings: {
      0: { label: t('settlement.verified'), tagType: 'success' },
      1: { label: t('settlement.notVoided'), tagType: 'primary' },
      2: { label: t('settlement.voided'), tagType: 'warning' },
      3: { label: t('settlement.creditAdjusted'), tagType: 'danger' },
      4: { label: t('settlement.partialCreditAdjusted'), tagType: 'danger' },
      5: { label: t('settlement.fullCreditAdjusted'), tagType: 'danger' },
      6: { label: t('settlement.invoiceDuplicate'), tagType: 'danger' },
      7: { label: t('settlement.verificationFailed'), tagType: 'danger' }
    },
    options: [
      { label: t('settlement.verified'), value: '0' },
      { label: t('settlement.notVoided'), value: '1' },
      { label: t('settlement.voided'), value: '2' },
      { label: t('settlement.creditAdjusted'), value: '3' },
      { label: t('settlement.partialCreditAdjusted'), value: '4' },
      { label: t('settlement.fullCreditAdjusted'), value: '5' },
      { label: t('settlement.invoiceDuplicate'), value: '6' },
      { label: t('settlement.verificationFailed'), value: '7' }
    ]
  }
}


